<section class="my-5">

  <!--Card-->
  <div class="card card-cascade narrower">

    <!--Section: Chart-->
    <section>

      <!--Grid row-->
      <div class="row">

        <!--stats-->
        <div class="col-xl-5 col-lg-12 mr-0">

          <!--Card image-->
          <div class="view view-cascade gradient-card-header blue-gradient">
            <h2 class="h2-responsive mb-0">Todays Standbys</h2>
            <span>(as of 12/7/18 11:16)</span>
          </div>
          <!--/Card image-->

          <!--Card content-->
          <div class="card-body card-body-cascade pb-0">
            <!--Panel data-->
            <div class="row card-body ">
              <div class="col-4">
                <small class="grey-text">Total Hours</small>
                <h4 class="h4-responsive">40:30</h4>
              </div>
              <div class="col-4">
                <small class="grey-text">Est. Pay</small>
                <h4 class="h4-responsive">$334</h4>
              </div>
              <div class="col-4">
                <small class="grey-text">Chauffeurs</small>
                <h4 class="h4-responsive">18</h4>
              </div>
              <div class="col-4">
                <small class="grey-text">Locations</small>
                <h4 class="h4-responsive">5</h4>
              </div>
              <div class="col-4">
                <small class="grey-text">Avg Time</small>
                <h4 class="h4-responsive">1:20</h4>
              </div>
              <div class="col-4">
                <small class="grey-text">Longest Time</small>
                <h4 class="h4-responsive">3:20</h4>
              </div>
            </div>
            <!--/Panel data-->
          </div>
          <!--/.Card content-->

        </div>
        <!--stats-->

        <!--chart-->
        <div class="col-xl-7 col-lg-12 my-5">

          <!--Card image-->
          <div class="view view-cascade  gradient-card-header white">
            <iframe class="chartjs-hidden-iframe" tabindex="-1" style="display: block; overflow: hidden; border: 0px; margin: 0px; top: 0px; left: 0px; bottom: 0px; right: 0px; height: 100%; width: 100%; position: absolute; pointer-events: none; z-index: -1;"></iframe>

            <!-- Chart -->
            <canvas mdbChart [chartType]="chartType" [datasets]="chartDatasets" [labels]="chart1Labels" [options]="chartOptions"
              [legend]="true">
            </canvas>

          </div>
          <!--/Card image-->

        </div>
        <!--chart-->

      </div>
      <!--Grid row-->

      <div class="row">
        <div div class="col-md-12 mr-0">

          <!--Card content-->
          <div class="card-body card-body-cascade pb-0">
            <h2 class="text-left">Los Angeles</h2>

            <!--Panel data-->
            <div class="row card-body pt-0">
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Total Hours</small>
                <h4 class="h4-responsive">12:49</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Est. Pay</small>
                <h4 class="h4-responsive">$131.85</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Chauffeurs</small>
                <h4 class="h4-responsive">5</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Locations</small>
                <h4 class="h4-responsive">2</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Avg Time</small>
                <h4 class="h4-responsive">1:36</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Longest Time</small>
                <h4 class="h4-responsive">3:12</h4>
              </div>
            </div>
            <!--/Panel data-->

            <h2 class="text-left mt-4">NY / NJ</h2>
            <div class="row card-body pt-0">
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Total Hours</small>
                <h4 class="h4-responsive">28:41</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Est. Pay</small>
                <h4 class="h4-responsive">$203.81</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Chauffeurs</small>
                <h4 class="h4-responsive">13</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Locations</small>
                <h4 class="h4-responsive">3</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Avg Time</small>
                <h4 class="h4-responsive">1:03</h4>
              </div>
              <div class="col-4 col-md-3 col-lg-2">
                <small class="grey-text">Longest Time</small>
                <h4 class="h4-responsive">3:20</h4>
              </div>
            </div>

          </div>
          <!--/.Card content-->

        </div>
      </div>

      <div class="row mb-3 justify-content-end">
        <div class="col-4 col-md-3 col-lg-2">
          <button mdbBtn type="button" gradient="blue" size="sm" [routerLink]="['day', 'today']" mdbWavesEffect>Details</button>
        </div>
      </div>

    </section>
    <!--Section: Chart-->

  </div>
  <!--/.Card-->

</section>